import JovoWebClientVue, { JovoWebClientVueConfig } from 'jovo-client-web-vue';
import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import EmbeddedChat from '@/components/EmbeddedChat.vue';

Vue.config.productionTip = false;
Vue.use( VueRouter );
console.log(process.env.BASE_URL)

const router = new VueRouter({
    mode: 'history',
    routes: [{
        path: process.env.BASE_URL||'/',
        name: 'home',
        component: EmbeddedChat
        },
        {
          path: (process.env.BASE_URL||'/') + 'redirect',
          name: 'redirect',
          component: EmbeddedChat
        }
      ],
});

Vue.use<JovoWebClientVueConfig>(JovoWebClientVue, {
//  url: process.env.VUE_APP_CLIENT_ENDPOINT_URL || 'https://skill-demo-beta.altervoice.net/webhook',
  url: process.env.VUE_APP_CLIENT_ENDPOINT_URL || 'https://skill-demo.altervoice.net/webhook',
  client: {
    audioPlayer: {
      enabled: false,
    },
    speechSynthesizer: {
      enabled: false,
      language: 'fr-FR'
//      voice:
    },
    speechRecognizer: {
      lang: 'fr',
      startDetection: {
        enabled: true,
      },
      silenceDetection: {
        enabled: true,
      },
    },
    repromptHandler: {
      enabled: false,
    },
    locale: 'fr',
    //appId: string;
    // version: Version;
    //platform: string;
    //device: Device;
    //audioRecorder: AudioRecorderConfig;
    store : {
      shouldPersistSession: false
    }
  }
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
